(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ReactSplitter", ["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactSplitter"] = factory(require("react"));
	else
		root["ReactSplitter"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__359__) => {
return 